// @flow
import React from 'react';
import CardCarousel from '@homeaway/react-card-carousel';
import PropertyCard from './PropertyCard/PropertyCard';
import type {PropertyCardListingShape} from './PropertyCard/PropertyCard';
import type {Node} from 'react';

import './PropertyCarousel.less';

type Props = {
    cardIndex?: number,
    isMobile: boolean,
    title: Node,
    breakpoints: Object,
    listings: PropertyCardListingShape[],
    onCarouselResize?: Function,
    seeMoreUrl?: string,
    withTripboardButton: boolean,
    withImagesCarousel: boolean,
    labelGenerator?: Function,
    onCardClick: Function,
    onCardEnter: Function,
    edapCollectionType?: string,
    locale?: string
};

const renderCards = (
    listings,
    isMobile,
    seeMoreUrl,
    withTripboardButton,
    withImagesCarousel,
    labelGenerator,
    onCardClick,
    onCardEnter,
    edapCollectionType,
    locale
) => {
    return listings.map((listing) => (
        <PropertyCard
            listing={listing}
            isMobile={isMobile}
            key={listing.listingId}
            seeMoreUrl={seeMoreUrl}
            withTripboardButton={withTripboardButton}
            withImagesCarousel={withImagesCarousel}
            labelGenerator={labelGenerator}
            onCardClick={onCardClick}
            onCardEnter={onCardEnter}
            edapCollectionType={edapCollectionType}
            locale={locale}
        />
    ));
};

export const PropertyCarousel = (props: Props) => {
    const {
        cardIndex,
        isMobile,
        title,
        breakpoints,
        onCarouselResize,
        onCardClick,
        onCardEnter,
        listings,
        seeMoreUrl,
        withTripboardButton,
        withImagesCarousel,
        labelGenerator,
        edapCollectionType,
        locale
    } = props;

    return (
        <CardCarousel
            breakpoints={breakpoints}
            scrolling={isMobile}
            title={title}
            cardIndex={cardIndex ? cardIndex : 0}
            onResize={
                onCarouselResize
                    ? onCarouselResize
                    : /* istanbul ignore next */ () => {}
            }
        >
            {renderCards(
                listings,
                isMobile,
                seeMoreUrl,
                withTripboardButton,
                withImagesCarousel,
                labelGenerator,
                onCardClick,
                onCardEnter,
                edapCollectionType,
                locale
            )}
        </CardCarousel>
    );
};

PropertyCarousel.defaultProps = {
    withTripboardButton: false,
    withImagesCarousel: false
};

export default PropertyCarousel;
